export const DC_DELETE_CATALOG_BEGIN = 'DC_DELETE_CATALOG_BEGIN';
export const DC_DELETE_CATALOG_SUCCESS = 'DC_DELETE_CATALOG_SUCCESS';
export const DC_DELETE_CATALOG_FAILURE = 'DC_DELETE_CATALOG_FAILURE';
export const DC_DELETE_CATALOG_DISMISS_ERROR = 'DC_DELETE_CATALOG_DISMISS_ERROR';
export const DC_SAVE_CATALOG_BEGIN = 'DC_SAVE_CATALOG_BEGIN';
export const DC_SAVE_CATALOG_SUCCESS = 'DC_SAVE_CATALOG_SUCCESS';
export const DC_SAVE_CATALOG_FAILURE = 'DC_SAVE_CATALOG_FAILURE';
export const DC_SAVE_CATALOG_DISMISS_ERROR = 'DC_SAVE_CATALOG_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/dc/redux/constants.js